import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { useReadingGoals } from '../../lib/ctx/reading_goals'
import { ReadingGoalsTabContent } from './ReadingGoalsTabContent'
import { ReadingGoalsLoader } from './ReadingGoalsLoader'

export const ReadingGoalsContent = () => {
  const [status, loadingSuggestions] = useReadingGoals((s) => [
    s.status,
    s.loadingSuggestions,
  ])

  return (
    <FlexBox
      className={css`
        width: 100%;
        min-height: 242px;
        border-radius: 16px;
      `}
    >
      {status === 'loading' || loadingSuggestions ? (
        <ReadingGoalsLoader />
      ) : (
        <ReadingGoalsTabContent />
      )}
    </FlexBox>
  )
}
